import view from '../../view';
import constants from '../constants/common';

const getClosestBlockByElementId = (elementId) => {
  const staticElement = view.accessors.getStaticElement(elementId);
  return staticElement.closest(`[id^='${constants.BLOCK_ID_PREFIX}']`);
};

export default getClosestBlockByElementId;
